import { tesEmployeesListingStore } from '@/app/features/tes-employees/features/tes-employees-listing/tes-employees-listing.store';
import { tesEmployeeDetailsStore } from '@/app/features/tes-employees/features/tes-employee-details/tes-employee-details.store';
import { newTesEmployeeStore } from '@/app/features/tes-employees/features/new-tes-employee/new-tes-employee.store.js';

export const tesEmployeesStore = {
  modules: {
    tesEmployeeListingsState: tesEmployeesListingStore,
    tesEmployeeDetailsState: tesEmployeeDetailsStore,
    newTesEmployeeState: newTesEmployeeStore
  }
};
